import { T } from '@tribeplatform/react-components/i18n'

import { EmailNotificationSettings } from '../EmailNotificationSettings.js'

export function EmailNotificationRouter() {
  return <EmailNotificationSettings />
}

export function EmailNotificationBreadCrumb() {
  return <T id="Notifications.Email" defaultMessage="Email Notifications" />
}
